import { ToslinkIcon } from './ToslinkIcon';

/**
 * author: Michael Irigoyen
 * id 207A1D36-F4A1-4ACB-B588-7BEA51C2E285
 * name toslink
 * version: 4.7.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/toslink.svg
 * tags
 * - Audio 
 */
export const OpticalAudioIcon = ToslinkIcon;
export default OpticalAudioIcon